import { List, DateField } from "@refinedev/antd";
import { useTable } from "@refinedev/core";
import { Table } from "antd";

type AuditRecord = {
  id: string;
  admin_id: string;
  action: string;
  resource: string;
  resource_id: string;
  ip_address: string;
  timestamp: string;
};

export const AuditList: React.FC = () => {
  const { tableQuery, currentPage, setCurrentPage, pageSize, setPageSize } = useTable<AuditRecord>({
    resource: "audit",
    pagination: {
      pageSize: 50,
    },
    sorters: {
      initial: [
        {
          field: "timestamp",
          order: "desc",
        },
      ],
    },
  });

  const getActionLabel = (action: string) => {
    const labels: Record<string, string> = {
      Login: "Zalogowano",
      Logout: "Wylogowano",
      Create: "Utworzono",
      Update: "Zaktualizowano",
      Delete: "Usunięto",
      View: "Wyświetlono",
    };
    return labels[action] || action;
  };

  return (
    <List title="Log Administratora">
      <Table<AuditRecord> dataSource={tableQuery.data?.data} loading={tableQuery.isLoading} rowKey="id"
        pagination={{ current: currentPage, pageSize, total: tableQuery.data?.total,
          onChange: (page, size) => { setCurrentPage(page); setPageSize(size); } }}>
        <Table.Column<AuditRecord> dataIndex="id" title="ID" />
        <Table.Column<AuditRecord> dataIndex="admin_id" title="ID Administratora" />
        <Table.Column<AuditRecord>
          dataIndex="action"
          title="Akcja"
          render={(value: string) => getActionLabel(value)}
        />
        <Table.Column<AuditRecord> dataIndex="resource" title="Zasób" />
        <Table.Column<AuditRecord> dataIndex="resource_id" title="ID Zasobu" />
        <Table.Column<AuditRecord>
          dataIndex="ip_address"
          title="Adres IP"
        />
        <Table.Column<AuditRecord>
          dataIndex="timestamp"
          title="Data"
          render={(value: string) => <DateField value={value} format="DD.MM.YYYY HH:mm:ss" />}
        />
      </Table>
    </List>
  );
};
